import type { SupabaseClient } from "@supabase/supabase-js";
// Both applications read the administrator-managed table, never Google's API.
// Explicit ranges avoid Supabase's default 1,000-row response ceiling.
export async function loadStoredVoiceCatalog<T extends { id: string }>(client: Pick<SupabaseClient, "from">, fields: string, activeOnly = true): Promise<T[]> {
  const rows: T[] = [], seen = new Set<string>(); let expected: number | null = null;
  for (let offset = 0; offset < 100000; offset += 500) {
    let q = client.from("voices").select(fields, { count: "exact" }).eq("provider", "gemini");
    if (activeOnly) q = q.eq("is_active", true);
    const { data, count, error } = await q.order("display_name", { ascending: true }).order("id", { ascending: true }).range(offset, offset + 499);
    if (error) throw error;
    if (!Number.isSafeInteger(count) || count! < 0) throw new Error("Voice catalog count is unavailable. Please refresh.");
    if (expected !== null && count !== expected) throw new Error("Voice catalog changed while loading. Please refresh.");
    expected = count;
    const page = (data ?? []) as unknown as T[];
    for (const row of page) {
      if (!row.id || seen.has(row.id)) throw new Error("Voice catalog changed while loading. Please refresh.");
      seen.add(row.id); rows.push(row);
    }
    if (rows.length === expected) return rows;
    if (!page.length || rows.length > expected!) throw new Error("Voice catalog was incomplete. Please refresh.");
  }
  throw new Error("Voice catalog exceeds the supported size.");
}
